// import { solidstate } from ":setup/qstate";
import { toast } from "solid-sonner";
import type { Payload } from "./_model";
// import Toast from "./main";

// export const $toasts = solidstate.create<Payload[]>([]);
export const actions = {
  pushToast(payload: Payload) {
    // $toasts.set((s) => [...s, alert]);
    // toast.custom((id) => Toast({ id, payload }), {
    //   position: "bottom-right",
    //   // class: "bg-red",
    //   // unstyled: true,
    // });
    const clazz = "px-2 py-3 text-16px border-3 border-solid ";
    switch (payload.type) {
      case "error":
        toast.error(payload.message, { class: clazz });
        break;
      case "success":
        toast.success(payload.message, { class: clazz });
        break;
      case "warning":
        toast.warning(payload.message, { class: clazz });
        break;
      default:
        toast.info(payload.message, { class: clazz });
        break;
    }
  },
};
